import { ReactNode } from 'react';
import { ApolloError } from 'apollo-client';
import { FieldArrayRenderProps, FormikProps } from 'formik';

import { ContentInput, ManualPostMutation } from 'api';
import { PostState, UserGroup } from 'types/app';

interface IHandleCompletedOptions {
  i18nKey: string;
  showNotification: boolean;
}

export enum RemoveTypes {
  Url = 'url',
  Photo = 'photo',
  Video = 'video',
}

export interface IPostForm {
  handleError: (error: ApolloError) => void;
  handleCompleted: (result: ManualPostMutation, options: IHandleCompletedOptions) => void;
  renderEditor: (props: FormikProps<ContentInput>) => ReactNode;
}

export interface IPostRenderProps {
  selectedGroup?: UserGroup;
  groupIds: string[];
  isChanging: boolean;
  toggleState: (mode: PostState) => void;
  toggleWork: () => void;
}

export type HandleGroupToggle = (
  values: ContentInput,
) => (group: UserGroup, arrayHelpers: FieldArrayRenderProps) => void;
export type PostForm = IPostForm & IPostRenderProps;
